import { ArrowUpRight } from '@phosphor-icons/react';
import { usePublicProfileData } from '@/context/PublicProfileContext';
import { useLinkTap } from '@/hooks/useLinkTap';
import { PlatformIcon } from '@/components/shared/PlatformIcon';
import { serviceMeta } from '@/data/services';
import type { PlatformService } from '@/data/services';

export function Platforms() {
  const { links } = usePublicProfileData();
  const tap = useLinkTap();

  const platforms = links.filter((l) => l.kind === 'platform');
  if (platforms.length === 0) return null;

  return (
    <>
      <div className="ap-divider" />
      <section id="platforms">
        <h2 className="ap-section__title">Stream</h2>
        <div className="ap-platforms">
          {platforms.map((p) => {
            const meta = serviceMeta(p.service);
            return (
              <div
                key={p.id}
                className="ap-platform"
                style={
                  { '--platform-color': meta?.color } as React.CSSProperties
                }
              >
                <span className="ap-platform__icon">
                  <PlatformIcon icon={p.service as PlatformService} />
                </span>
                <span className="ap-platform__name">
                  {meta?.name ?? p.service}
                </span>
                <a
                  href={p.url}
                  className="ap-visit"
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Open ${meta?.name ?? p.service}`}
                  onClick={() => tap(p.id)}
                >
                  <ArrowUpRight size={14} weight="bold" />
                </a>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
